import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import store from './reducers/store';
import '@fontsource/open-sans/cyrillic-700.css';
import '@fontsource/open-sans/cyrillic-400.css';
import '@fontsource/open-sans/cyrillic-ext-700.css';
import '@fontsource/open-sans/cyrillic-ext-400.css';
import '@fontsource/open-sans/latin-ext-700.css';
import '@fontsource/open-sans/latin-ext-400.css';

import '/node_modules/flag-icons/css/flag-icons.min.css';
import ThemeProvider from '@tcc-online/react-theme-provider';

const {
    REACT_APP_SENTRY_DSN,
    REACT_APP_SENTRY_SAMPLE_RATE,
    REACT_APP_ENVIRONMENT,
    REACT_APP_VERSION,
} = import.meta.env;

if (REACT_APP_SENTRY_DSN) {
    Sentry.init({
        dsn: REACT_APP_SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: parseFloat(REACT_APP_SENTRY_SAMPLE_RATE),
        environment: REACT_APP_ENVIRONMENT,
        release: REACT_APP_VERSION,
    });
}

const container = document.getElementById('root');

const root = createRoot(container as any);

root.render(
    <Sentry.ErrorBoundary>
        <Provider store={store}>
            <BrowserRouter>
                <ThemeProvider>
                    <App />
                </ThemeProvider>
            </BrowserRouter>
        </Provider>
    </Sentry.ErrorBoundary>,
);
